<template>
  <div class="log pl-2">
    <button
      target="_blank"
      type="button"
      class="track-ass-btn m-t-10 m-l-10 green-button tender-action-btn tender-action-btn--withdraw"
      title="Details"
      :disabled="loading"
      @click.stop="check()"
    >
      Withdraw
    </button>

    <v-dialog
      v-model="dialog3"
      max-width="28rem"
      content-class="tender-withdraw-dialog"
    >
      <v-form ref="form">
        <v-card class="comments-view tender-withdraw-card">
          <header class="tender-withdraw-header">
            <div class="tender-withdraw-header__brand">
              <div class="tender-withdraw-header__badge" aria-hidden="true">
                <v-icon>undo</v-icon>
              </div>
              <div class="tender-withdraw-header__copy">
                <h2 class="tender-withdraw-title">Withdraw Job</h2>
                <p class="tender-withdraw-subtitle">
                  Job Id {{ detail.jobId || "—" }}
                </p>
              </div>
            </div>
            <v-btn
              icon
              class="tender-withdraw-close"
              @click.prevent="dialog3 = false"
              title="Close"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </header>

          <v-card-text class="tender-withdraw-body">
            <div class="tender-withdraw-panel">
              <div class="tender-withdraw-row">
                <span class="tender-withdraw-label">Bid Model</span>
                <strong class="tender-withdraw-value">Bid</strong>
              </div>
              <div class="tender-withdraw-row">
                <span class="tender-withdraw-label">Start Date</span>
                <strong class="tender-withdraw-value">
                  {{ getTimes(detail.startDate) }}, {{ detail.pickupTime }}
                </strong>
              </div>
              <div class="tender-withdraw-row">
                <span class="tender-withdraw-label">Expiry Date</span>
                <strong class="tender-withdraw-value">
                  {{ getTime(detail.closedDate) }}
                </strong>
              </div>
              <div class="tender-withdraw-row">
                <span class="tender-withdraw-label">Job Price</span>
                <strong class="tender-withdraw-value">
                  {{ $formatPrice(detail.jobPrice) }}
                  {{ detail.transporterCurrency }}
                </strong>
              </div>
              <div class="tender-withdraw-row">
                <span class="tender-withdraw-label">Bid Price</span>
                <strong class="tender-withdraw-value">
                  <template v-if="detail.amountForTransporter">
                    {{ $formatPrice(detail.amountForTransporter) }}
                    {{ detail.transporterCurrency }}
                  </template>
                  <template v-else>N.A</template>
                </strong>
              </div>
              <div class="tender-withdraw-row">
                <span class="tender-withdraw-label">Truck Required</span>
                <strong class="tender-withdraw-value">
                  {{ detail.requiredTrucks }}
                </strong>
              </div>
              <div class="tender-withdraw-row">
                <span class="tender-withdraw-label">Truck Remaining</span>
                <strong class="tender-withdraw-value">
                  {{ detail.remainingTruck }}
                </strong>
              </div>
            </div>

            <div class="tender-withdraw-actions">
              <v-btn
                flat
                class="tender-withdraw-cancel"
                @click.prevent="dialog3 = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="orange darken-1"
                class="px-2 white--text tender-withdraw-confirm"
                @click="open(detail)"
              >
                Confirm
              </v-btn>
            </div>
          </v-card-text>

          <v-snackbar
            :timeout="6000"
            bottom
            color="red darken-2"
            v-model="x.error"
            class="white--text"
            v-if="x.error"
            >{{ x.error }}</v-snackbar
          >

          <v-dialog
            v-model="dialog4"
            persistent
            :max-width="options.width"
            :style="{ zIndex: options.zIndex }"
            content-class="tender-withdraw-confirm-dialog"
            @keydown.esc="cancel"
          >
            <v-card class="tender-withdraw-confirm-card">
              <header class="tender-withdraw-header">
                <div class="tender-withdraw-header__brand">
                  <div class="tender-withdraw-header__badge" aria-hidden="true">
                    <v-icon>warning</v-icon>
                  </div>
                  <h2 class="tender-withdraw-title">{{ title }}</h2>
                </div>
              </header>
              <v-card-text
                class="tender-withdraw-confirm-body"
                v-show="!!message"
              >
                <div v-if="errorMessage" class="tender-withdraw-warning">
                  {{ errorMessage }}
                </div>
                <div class="tender-withdraw-confirm-text">{{ message }}</div>
              </v-card-text>
              <v-card-actions class="tender-withdraw-actions">
                <v-btn
                  flat
                  class="tender-withdraw-cancel"
                  @click.native="cancel"
                  >No</v-btn
                >
                <v-btn
                  color="orange darken-1"
                  class="white--text tender-withdraw-confirm"
                  @click.native="agree"
                  >Yes</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { StorageKeys } from "../../constants/constants";
import { tenderSectionApiUrl } from "@/constants/api-urls.js";
import ErrorBox from "@/components/Common/ErrorBox";
export default {
  name: "WithDrawJobs",
  created() {},
  data() {
    return {
      operation: "",
      operationName: "",
      id: "",
      x: {
        error: null,
      },
      options: {
        color: "#ffc04c",
        width: 450,
        zIndex: 200,
      },
      items: [],

      title: null,
      message: null,
      errorMessage: null,
      cancelTitle: null,
      cancelMessage: null,

      cancelComments: "",
      processing: false,
      reason: "",
      dialog3: false,
      dialog4: false,
      disStatus: false,
      loading: false,
      rules: {
        required: (value) => !!value || "This field is required.",
      },
    };
  },
  props: {
    detail: Object,
  },

  methods: {
    async check() {
      this.loading = true;
      this.operationName = "withdraw-job";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.dialog3 = true;
        this.loading = false;
      } else {
        this.loading = false;
        return;
      }
    },
    getTime3(date) {
      return moment.utc(date).format("DD/MM/YYYY");
    },
    getTimes(time) {
      return moment.unix(time).format("DD/MM/YYYY");
    },
    getTime(date) {
      return moment(date).format("DD/MM/YYYY, HH:mm");
    },
    open(val) {
      this.errorMessage = null;
      this.message = null;
      if (!navigator.onLine) {
        this.loading = false;
        this.x.error = "Please check your internet connection";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return;
      }

      this.id = val.jobId;
      if (val.obtainedTrucks != val.requiredTrucks) {
        this.errorMessage =
          "Withdrawing this job will remove job from transporter.";
        this.message = "Are you sure want to withdraw this job?";
      } else {
        this.message = "Are you sure want to withdraw this job?";
      }
      this.dialog4 = true;
      this.dialog3 = false;
      this.title = "Withdraw Job";

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);

      this.withdraw(this.id);
      this.dialog4 = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog4 = false;
    },
    async withdraw(value) {
      this.operationName = "withdraw-job";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.loading = true;
        let url = tenderSectionApiUrl.withDrawBid;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };

        let body = {
          jobId: value.toString(),
        };

        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.$emit("refreshJobs", this.detail);
            this.dialog4 = false;
            this.loading = false;
          },
          (error) => {
            this.$emit("error", error.response.data.message);
            this.loading = false;

            this.x.error = error.response.data.message;
          }
        );
      } else {
        return;
      }
    },
  },
};
</script>
<style scoped>
.tender-withdraw-header {
  align-items: center;
  background:
    radial-gradient(circle at 100% 0%, rgba(245, 130, 32, 0.14), transparent 42%),
    linear-gradient(135deg, #fff7ed 0%, #ffffff 55%, #f4f7fb 100%);
  border-bottom: 0.0625rem solid #fed7aa;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 0.85rem 1rem;
}

.tender-withdraw-header__brand {
  align-items: center;
  display: flex;
  gap: 0.7rem;
  min-width: 0;
}

.tender-withdraw-header__badge {
  align-items: center;
  background: linear-gradient(160deg, #1c2b5f 0%, #2a3f7a 100%);
  border-radius: 0.7rem;
  box-shadow: 0 0.35rem 0.75rem rgba(28, 43, 95, 0.22);
  display: inline-flex;
  flex: 0 0 auto;
  height: 2.35rem;
  justify-content: center;
  width: 2.35rem;
}

.tender-withdraw-header__badge .v-icon {
  color: #ffffff !important;
  font-size: 1.05rem !important;
}

.tender-withdraw-title {
  color: #1c2b5f !important;
  font-size: 1rem !important;
  font-weight: 800 !important;
  letter-spacing: -0.01em;
  line-height: 1.2;
  margin: 0;
}

.tender-withdraw-subtitle {
  color: #c35f02;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.75rem;
  font-weight: 700;
  margin: 0.15rem 0 0;
}

.tender-withdraw-close {
  color: #5b6475 !important;
}

.tender-withdraw-body.v-card__text {
  padding: 1rem 1.15rem 1.15rem !important;
}

.tender-withdraw-panel {
  background: #fffaf4;
  border: 0.0625rem solid #fed7aa;
  border-radius: 0.85rem;
  overflow: hidden;
}

.tender-withdraw-row {
  align-items: center;
  border-bottom: 0.0625rem solid #f3e6d4;
  display: grid;
  gap: 0.75rem;
  grid-template-columns: minmax(7.5rem, 9rem) minmax(0, 1fr);
  min-height: 2.55rem;
  padding: 0.55rem 0.9rem;
}

.tender-withdraw-row:last-child {
  border-bottom: 0;
}

.tender-withdraw-label {
  color: #8a857c;
  font-size: 0.6875rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.tender-withdraw-value {
  color: #1a1916;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.35;
}

.tender-withdraw-actions {
  align-items: center;
  background: #fffaf4;
  border: 0.0625rem solid #fed7aa;
  border-radius: 0.75rem;
  display: flex;
  gap: 0.55rem;
  justify-content: flex-end;
  margin-top: 0.85rem;
  padding: 0.7rem 0.85rem;
}

.tender-withdraw-cancel.v-btn {
  color: #5b6475 !important;
  font-weight: 700 !important;
  text-transform: none !important;
}

.tender-withdraw-confirm.v-btn {
  border-radius: 0.5rem !important;
  font-weight: 800 !important;
  text-transform: none !important;
}

.tender-withdraw-confirm-body {
  padding: 1rem 1.15rem !important;
  text-align: center;
}

.tender-withdraw-warning {
  color: #b45309;
  font-size: 0.8125rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.tender-withdraw-confirm-text {
  color: #1a1916;
  font-size: 0.9rem;
  font-weight: 700;
}
</style>

<style>
.application .v-dialog.tender-withdraw-dialog,
.application .v-dialog.tender-withdraw-confirm-dialog {
  border-radius: 1rem !important;
  overflow: hidden !important;
}

.application .v-dialog.tender-withdraw-dialog .tender-withdraw-card,
.application .v-dialog.tender-withdraw-confirm-dialog .tender-withdraw-confirm-card {
  background: #ffffff !important;
  border-radius: 1rem !important;
  box-shadow: none !important;
  overflow: hidden;
}
</style>
